module.exports = __webpack_public_path__ + "img/undraw_chat-with-ai_ir62.e44f0304.svg";